// React
import { useContext } from "react"

// Components
import { DateInput } from "components"

// Contexts
import { DisabledContext } from "../../contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

// Types
import type { FormType } from "../utils"
import { useApprovalStore } from "../../utils"

export function TransactionDate(): JSX.Element {
  // Hooks
  const disabled = useContext(DisabledContext)

  // Form
  const { control } = useFormContext<FormType>()
  const { isView } = useApprovalStore()

  return (
    <Controller
      name="transaction_date"
      control={control}
      render={({ field, fieldState }) => (
        <DateInput
          label="PAYMENT DATE"
          disabled={disabled || isView}
          error={fieldState.error?.message}
          selected={moment(field.value).toDate()}
          ref={field.ref}
          onChange={(date) => {
            // Vars
            const selectedDate = moment(date).format("YYYY-MM-DD")

            field.onChange(selectedDate)
          }}
        />
      )}
    />
  )
}